// extracted by mini-css-extract-plugin
module.exports = {"header-text":"status-header__header-text___2E3M_"};